import { BaseElement, defineElement } from "./lib-element-js.min.js";

class SectionAnimation extends BaseElement {
  // lifecycle hook
  connected() {
    this.observe();
  }

  // reactive attributes/properties
  properties() {
    return {
      visible: false,
    };
  }

  // watchers for property changes
  watch() {
    return {
      visible: (newValue, oldValue) => {
        console.log("visible changed", newValue, oldValue);
      },
    };
  }

  // computed property
  // get computedMsg() {
  //   return `${this.greeting} ${this.name} ${this.familyName}`;
  // }

  // method
  observe() {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.setVisible();
          }
        });
      },
      {
        rootMargin: "-150px",
      }
    );
    observer.observe(this);
  }

  setVisible() {
    if (!this.visible) {
      this.classList.add("animated");
    }
  }
}
defineElement("section-animation", SectionAnimation);
